module.exports = __webpack_public_path__ + "a77dc2a68a161c3f295984594b83e707.svg";